import {deleteServiceAuthorized, getService, getServiceAuthorized, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized, putServiceAuthorized} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';
const ProfileService = {};

ProfileService.getProfile = (id) => AxiosRequest.get(
    `/${route.registration}/api/v4/registrationProfileNode/myProfileDetails/${id}?`
  );

  ProfileService.getPersonalInfo = (token) => AxiosRequest.get(
    `/${route.registration}/api/v1/registrationProfileNode/user/profile?`,
    token,
  );
  ProfileService.updatePersonalInformation = (payload) => AxiosRequest.post(
    `/${route.registration}/api/v3/registrationProfileNode/update/user/profile`,
    payload,
  );
  ProfileService.sendOTP = (payload) => AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/verify/contact/number`,
    payload,
  );
  ProfileService.changePassword = (payload) => AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/change/password`,
    payload,
  );
  ProfileService.getBockedTds = () => AxiosRequest.get(
    `/${route.pointAccrual}/api/v2/pointsNode/getAllBlockPoints?`,
  );
  ProfileService.getAvailablePointsRedeemable = (date_from = '',
    date_to = '',
    trans_type = '',
    trans_desc = '',
    limit,
    pageNo,
  ) =>
    AxiosRequest.get(
      `/${route.pointAccrual}/api/v2/pointsNode/getPointDescDetails?date_from=${
        date_from != '' ? String(date_from) : ''
      }&date_to=${date_to != '' ? String(date_to) : ''}&trans_type=${
        trans_type != '' ? String(trans_type) : ''
      }&trans_desc=${
        trans_desc != '' ? String(trans_desc) : ''
      }&limit=${limit}&offset=${(pageNo - 1) * limit}`
    );
  
  ProfileService.getAvailablePoints = (date_from='',date_to='') => AxiosRequest.get(
    `/${route.pointAccrual}/api/v1/pointsNode/getAvailablePoints?date_from=${date_from!=''?String(date_from):''}&date_to=${date_to!=''?String(date_to):''}`,
  );
  ProfileService.getAvailablePointsNew = ( date_from = '', date_to = '') =>
  AxiosRequest.get(
    `/${route.pointAccrual}/api/v2/pointsNode/getPoints?date_from=${
      date_from != '' ? String(date_from) : ''
    }&date_to=${date_to != '' ? String(date_to) : ''}`,
  );
  ProfileService.getAvailablePointsearned = (
    date_from = '',
    date_to = '',
  ) =>
    AxiosRequest.get(
      `/${route.pointAccrual}/api/v2/pointsNode/getPointMonthDetails?date_from=${
        date_from != '' ? String(date_from) : ''
      }&date_to=${date_to != '' ? String(date_to) : ''}`,
    );
    
    ProfileService.getPointsEarnedDetailsView = (
      month_number = '',
      year_number = '',
      trans_type = '',
      trans_desc = '',
      limit,
      pageNo,
    ) =>
      AxiosRequest.get(
        `/${
          route.pointAccrual
        }/api/v2/pointsNode/getMonthlyTrans/${month_number}/${year_number}?trans_type=${
          trans_type != '' ? String(trans_type) : ''
        }&trans_desc=${
          trans_desc != '' ? String(trans_desc) : ''
        }&limit=${limit}&offset=${(pageNo - 1) * limit}`,
      );
      
  ProfileService.getCompanyDetails = (token) => AxiosRequest.get(
    `/${route.registration}/api/v1/profileNode/get/company/detail?`,
    token,
  );
  ProfileService.getBrand = () => AxiosRequest.get(
    `/${route.registration}/api/v1/registrationProfileNode/get/brand?`,
  );
  ProfileService.getWishlist = () => AxiosRequest.get(
    `/${route.cart}/api/v1/wishlists`,
  );

  ProfileService.updateEkycInformation = (payload) =>  AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/update/user/kyc`,
    payload,
  )
  ProfileService.updateGeoLocation = (payload) => AxiosRequest.post(
    `/${route.registration}/api/v1/profileNode/insert/geoLocation`,
    payload,
  );

  ProfileService.updateProfileImage = (payload) => AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/profile/picture/update`,
    payload,
  );
  // My performance Actual vs Target
  ProfileService.getMyPerformance  = (startDate,endDate) => AxiosRequest.get(
    `/${route.pointAccrual}/api/v1/salesNode/get/all/sale/target/by/contactId?startDate=${startDate}&endDate=${endDate}`,
  )

  ProfileService.getLoginBrand = (payload) =>
  AxiosRequest.post(`/${route.auth}/api/v2/authNode/getbranddetails`, payload);

  ProfileService.uploadEkycDoc = (formData) =>
  AxiosRequest.postForm(
    `/${route.registration}/api/v3/profileNode/kyc/update`,
    formData
  );

  ProfileService.updateEkycInformation = (payload) =>
  AxiosRequest.post(
    `/${route.registration}/api/v1/registrationProfileNode/update/user/kyc`,
    payload
  );

  ProfileService.getKYCDetails = (payload) =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/registrationsNode/checkUserByBrand`,
      payload
    );

  ProfileService.getInsuranceData = (conId) => 
    AxiosRequest.get(
      `/${route.registration}/api/v1/insurance/user/${conId}?`,
      // token,
    );

  ProfileService.uploadSelfie = (formData, token) =>
    AxiosRequest.postForm(
      `/${route.registration}/api/v3/registrationProfileNode/upload/selfie`,
      formData,
      token,
    );

  ProfileService.fetchScratchCardDeatails = (id) =>
    AxiosRequest.get(
      `/${route.pointAccrual}/api/v1/salesNode/scratch/card/details?selfie_config_id=${id}`,
    );

  ProfileService.scratchStatus = (selfieId) =>
    AxiosRequest.post(
      `/${route.pointAccrual}/api/v1/salesNode/scratch/card/edit`,
      { selfie_config_id: selfieId }
    );

  ProfileService.uploadAndVerifyEKYC = formData =>
    AxiosRequest.post(
      `/${route.registration}/api/v3/registrationProfileNode/upload/uploadAndVerifyEKYC`,
      formData,
    );

export default ProfileService;